package com.hyperether.goodjob.util

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.contentOrNull
import kotlinx.serialization.json.jsonPrimitive

object JWTUtils {
    fun extractClaims(idToken: String?): JwtClaims? {
        idToken ?: return null

        println("JWTUtils: token: $idToken")
        val parts = idToken.split(".")
        if (parts.size < 2) return null

        val payloadBase64 = parts[1]
            .replace("-", "+")
            .replace("_", "/")
            .let {
                val padding = (4 - it.length % 4) % 4
                it + "=".repeat(padding)
            }

        return try {
            val decoded = decodeBase64(payloadBase64) ?: return null
            val json = Json.decodeFromString<JsonObject>(decoded)
            println("JWTUtils: json: $json")

            val email = json["email"]?.jsonPrimitive?.contentOrNull
                ?: json["preferred_username"]?.jsonPrimitive?.contentOrNull
            val sub = json["tid"]?.jsonPrimitive?.contentOrNull
                ?: json["sub"]?.jsonPrimitive?.contentOrNull
            val name = json["name"]?.jsonPrimitive?.contentOrNull

            JwtClaims(
                sub = sub,
                email = email,
                name = name
            )
        } catch (e: Exception) {
            null
        }
    }
}

data class JwtClaims(
    val sub: String?,
    val email: String?,
    val name: String?
)

expect fun decodeBase64(base64: String): String?